import React from "react";
import { Form, Input, Checkbox, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Logo from "../../assests/Logos.svg";

const Signup = () => {
  const navigate = useNavigate();

  const onFinish = async (values: {
    name: string;
    email: string;
    password: string;
    confirmPassword: string;
  }) => {
    if (values.password !== values.confirmPassword) {
      toast.error("Passwords do not match", { position: "top-right" });
      return;
    }

    try {
      toast.success("Account created successfully!", { position: "top-right" });
      navigate("/login");
    } catch (error) {
      toast.error("Signup failed. Please try again.", {
        position: "top-right",
      });
    }
  };

  return (
    <div className="min-h-screen bg-black flex justify-center items-center px-4">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg overflow-hidden relative">
        {/* Top Gradient + Logo */}
        <div className="bg-gradient-to-b from-white via-blue-100 to-transparent py-6 flex justify-center">
          <img src={Logo} alt="MERC Logo" className="w-28 h-auto" />
        </div>

        {/* Form Content */}
        <div className="px-6 py-6">
          <h2 className="text-2xl font-semibold text-center text-gray-800 mb-3">
            Create Account
          </h2>

          <Form layout="vertical" onFinish={onFinish}>
            <div className="flex flex-col md:flex-row gap-4">
              <Form.Item
                name="name"
                label={<span className="text-gray-600 text-sm">Full Name</span>}
                rules={[
                  { required: true, message: "Please enter your full name!" },
                ]}
                className="w-full"
              >
                <Input
                  placeholder="Full Name"
                  className="py-3 px-4 rounded-lg border-gray-300"
                />
              </Form.Item>

              <Form.Item
                name="email"
                label={<span className="text-gray-600 text-sm">Email</span>}
                rules={[
                  { required: true, message: "Please enter your email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
                className="w-full"
              >
                <Input
                  placeholder="you@example.com"
                  className="py-3 px-4 rounded-lg border-gray-300"
                />
              </Form.Item>
            </div>
            <div className="flex flex-col md:flex-row gap-4">
              <Form.Item
                name="password"
                label={<span className="text-gray-600 text-sm">Password</span>}
                rules={[
                  { required: true, message: "Please enter a password!" },
                ]}
                className="w-full"
              >
                <Input.Password
                  placeholder="Password"
                  className="py-3 px-4 rounded-lg border-gray-300"
                />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label={
                  <span className="text-gray-600 text-sm">
                    Confirm Password
                  </span>
                }
                rules={[
                  { required: true, message: "Please confirm your password!" },
                ]}
                className="w-full"
              >
                <Input.Password
                  placeholder="Confirm Password"
                  className="py-3 px-4 rounded-lg border-gray-300"
                />
              </Form.Item>
            </div>
            <Form.Item
              name="agreement"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject("You must accept the terms"),
                },
              ]}
            >
              <Checkbox className="text-sm text-gray-600">
                I agree to the{" "}
                <a href="/terms" className="text-blue-500 underline">
                  terms and conditions
                </a>
              </Checkbox>
            </Form.Item>

            <Form.Item>
              <Button
                htmlType="submit"
                className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg"
                size="large"
              >
                Sign Up
              </Button>
            </Form.Item>
          </Form>
          <div className="text-center text-sm mt-2 pt-3 border-t border-gray-200">
            Already have an account?{" "}
            <Link
              to="/"
              className="text-blue-500 hover:underline font-medium"
            >
              Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
